export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  AUTH_ERROR: 'auth_error',
  DESTINATION: 'auth_destination',
  RESUME_REDIRECT_AT: 'auth_resume_redirect_at',
} as const;

export const AUTH_ROUTES = {
  LOGIN: '/user/login',
  LOGOUT: '/user/logout',
  TFA_SETUP: '/user/login/setup',
  VERIFY: '/user/login/verify',
  K1_INITIATE: '/kaseyaone/initiate/login',
  K1_ENABLE_CALLBACK: '/kaseyaone/enable/callback',
  K1_DISABLE_CALLBACK: '/kaseyaone/disable/callback',
  DEV_LOGIN: '/v2/dev-login/:token',
  RESET_PASSWORD: '/v2/reset/password/:token',
  K1_CALLBACK: '/v2/k1/callback',
  LOGOUT_CALLBACK: '/v2/logout/callback',
} as const;

// Auth URLs outside /v2 that nginx serves with the SPA shell, so the router owns them.
export const SPA_PATHS_OUTSIDE_V2: readonly string[] = [
  AUTH_ROUTES.LOGIN,
  AUTH_ROUTES.VERIFY,
  AUTH_ROUTES.TFA_SETUP,
  AUTH_ROUTES.LOGOUT,
  AUTH_ROUTES.K1_INITIATE,
  AUTH_ROUTES.K1_ENABLE_CALLBACK,
  AUTH_ROUTES.K1_DISABLE_CALLBACK,
];

export const RESET_LINK_EXPIRED_TOAST = {
  title: 'Link expired',
  subtitle: 'The password reset link has expired. Please request a new one.',
};

export const K1_LOGOUT_FAILED_MESSAGE = 'KaseyaOne log out failed, please try again.';

export const K1_LOGIN_REQUIRED_CODE = 'k1_login_required';

export const K1_LOGIN_FAILED_MESSAGE = 'KaseyaOne log in failed, please try again.';

export const TFA_SESSION_EXPIRED_CODE = 'tfa_session_expired';

export const TFA_SESSION_EXPIRED_MESSAGE = 'Your sign-in session has expired. Please sign in again.';

export const STEPS = {
  INFORMATION: 'INFORMATION',
  SETUP: 'SETUP',
  ALL_SET: 'ALL_SET',
} as const;

export type Step = (typeof STEPS)[keyof typeof STEPS];

export const CODE_VALIDATION_ERROR = 'The authentication code must be 6 digits.';

export const INVALID_EMAIL_ERROR = 'Please enter the valid email address associated with your account.';

export const EMAIL_FORMAT_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MFA_METHODS = {
  TOTP: 'totp',
  RECOVERY_CODE: 'recovery-code',
} as const;

export const PRODUCT_ID = 1; // dwid
